import {
  AppNotification,
  NotificationType,
} from '../../../components/notification/Notification'
import { useDeleteDebounce } from '../../../utils/useDeleteDebounce'

import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useArchiveMultiplePlanMenuTypeMutation } from '../../../core/api/PlanMenuTypeApi'
import { IChooseItems } from 'core/api/dto/BuffetDishDto'

interface UseDeletePlanMenuResponse {
  deletePopup: boolean
  onDeletePopupHandler: () => void
  onDeleteHandler: () => void
  closeDeletePopup: () => void
}

export const useDeletePlanMenuType = (
  chooseItems: IChooseItems | null,
  setChooseItems: React.Dispatch<React.SetStateAction<IChooseItems | null>>,
): UseDeletePlanMenuResponse => {
  const [deletePopup, setDeletePopup] = useState(false)
  const [archiveMultiplePlanMenuType] = useArchiveMultiplePlanMenuTypeMutation()
  const { t } = useTranslation()

  const deleteCategoryHandler = async () => {
    if (!!chooseItems) {
      archiveMultiplePlanMenuType({
        plan_menu_type_list: Object.keys(
          Object.fromEntries(
            Object.entries(chooseItems).filter((e) => e.includes(true)),
          ),
        ).map((item) => Number(item)),
      })
        .unwrap()
        .then(() => {
          AppNotification({
            msg: t('Выбранные типы план-меню успешно удалены!'),
            type: NotificationType.success,
          })
          setChooseItems(null)
        })
    }
  }

  const [onDeleteHandler] = useDeleteDebounce({
    fn: deleteCategoryHandler,
    extraText: t('Выбранные вами типы план-меню будут удалены!'),
  })

  const closeDeletePopup = () => setDeletePopup(false)
  const openDeletePopup = () => setDeletePopup(true)

  return {
    deletePopup,
    onDeletePopupHandler: openDeletePopup,
    onDeleteHandler,
    closeDeletePopup,
  }
}
